/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { Link } from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { useTranslation, initReactI18next } from 'react-i18next'
import { getOptionalTextModules, getSalesAreaLetter, getSectorAll } from '../../../../api/modules/getdatalist'
import { createOptionalText } from '../../../../api/modules/letterconfig'
// import {Editor} from '@tinymce/tinymce-react'
import { useNavigate } from 'react-router-dom'
import swal from 'sweetalert'
import { Spinner } from 'react-bootstrap'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useIntl } from 'react-intl'

import Editor from 'src/app/components/Editor'
import { RichText } from 'src/components'

type Props = {
  className: string
}

const AddOptionalText: React.FC<Props> = ({ className }) => {
  const intl = useIntl()
  const { t } = useTranslation()

  const [tiny, setTiny] = useState<any>()

  const editorRef: any = useRef()

  const onClickHandler = () => {
    setTiny(editorRef.current.getContent())
  }

  var parse: any = require('html-react-parser')

  const [fullModules, setFullModules] = useState<any[]>([])
  const [fullSales, setFullSales] = useState<any[]>([])
  const [fullSectors, setFullSectors] = useState<any[]>([])
  const [sales, setSales] = useState('')
  const [module, setModule] = useState('')
  const [sector, setSector] = useState('')
  const [content, setContent] = useState('')
  const [roleUser, setRoleUser] = useState('')
  const navigate = useNavigate()

  const [btnLoading, setBtnLoading] = useState(false)

  const [sailingDate, setSailingDate] = useState<any>(null)
  const [custPICName, setCustPICName] = useState<any>(null)
  const [custPICPosition, setCustPICPosition] = useState<any>(null)
  const [portLoading, setPortLoading] = useState<any>(null)
  const [textBAST, setTextBAST] = useState<any>(null)
  const [textBASTEn, setTextBASTEn] = useState<any>(null)
  const [salesDivision, setSalesDivision] = useState<any>(null)
  const [picSalesDivision, setPicSalesDivision] = useState<any>(null)
  const [TOS, setTOS] = useState<any>(null)
  const [TOSEn, setTOSEn] = useState<any>(null)
  const [TOSsi, setTOSsi] = useState<any>(null)
  const [TOSsiEn, setTOSsiEn] = useState<any>(null)
  const [attn, setAttn] = useState<any>(null)
  const [attnEn, setAttnEn] = useState<any>(null)
  const [penutup, setPenutup] = useState<any>(null)
  const [penutupEn, setPenutupEn] = useState<any>(null)
  const [ETA, setETA] = useState<any>(null)
  const [textKeterangan, setTextKeterangan] = useState<any>(null)
  const [textKeteranganEn, setTextKeteranganEn] = useState<any>(null)
  const [referensi, setReferensi] = useState<any>(null)
  const [referensiEn, setReferensiEn] = useState<any>(null)
  const [shippingInstruction, setShippingInstruction] = useState<any>(null)
  const [invoice, setInvoice] = useState<any>(null)
  const [invoiceEn, setInvoiceEn] = useState<any>(null)
  const [addTextLanguage, setAddTextLanguage] = useState('id')
  const [noExport, setNoExport] = useState('')

  useEffect(() => {
    const getSales = async () => {
      await getSalesAreaLetter().then((res) => {
        setFullSales(res.data.data)
      })
    }

    const getSector = async () => {
      const res = await getSectorAll()
      setFullSectors(res.data.data)
    }

    const getModules = async () => {
      const res = await getOptionalTextModules()
      setFullModules(res.data.data?.map((item: any) => ({
        label: item,
        value: item
      })))
    }

    getSales()
    getSector()
    getModules()
    setRoleUser(localStorage.getItem('role-flag')!)
  }, [])

  const handleUpload = async () => {
    setBtnLoading(true)

    await createOptionalText({
      'sales_org_code': sales,
      'sector_id': sector,
      'module': module,
      'title': null,
      'title_en': null,
      'mail_body': null,
      'mail_body_en': null,
      'lain_lain': null,
      'lain_lain_en': null,
      'customer_pic_name': custPICName,
      'customer_pic_position': custPICPosition,
      'sailing_date': sailingDate,
      'port_of_loading': portLoading,
      'port_of_discharge': null,
      'additional_text_bast': null,
      'additional_text_bast_en': null,
      'sales_division': salesDivision,
      'pic_sales_division': picSalesDivision,
      'terms_and_conditions': null,
      'terms_and_conditions_en': null,
      'terms_and_conditions_si': null,
      'terms_and_conditions_si_en': null,
      'customer_attn': attn,
      'customer_attn_en': attnEn,
      'text_penutup': penutup,
      'text_penutup_en': penutupEn,
      'keterangan': textKeterangan,
      'keterangan_en': textKeteranganEn,
      'referensi': referensi,
      'referensi_en': referensiEn,
      'tanggal_shipping_instruction': shippingInstruction,
      'invoice_notes': invoice,
      'invoice_notes_en': invoiceEn,
      'financial_assigner_name': null,
      'financial_assigner_position': null,
      'eta_moda_angkut': ETA,
      'no_izin_export': noExport,
    })
      .then((res) => {
        swal({
          title: `${t('configuration-submited')}`,
          icon: 'success',
        }).then(() => navigate('/config/additional-text'))
      })
      .catch((error) => {
        swal({
          closeOnClickOutside: false,
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const handleOpenn = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('a')) {
      icon?.classList.remove('a')
      icon?.classList.add('b')
    } else {
      icon?.classList.remove('b')
      icon?.classList.add('a')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    if (fold) {
      fold.classList.toggle('foldd-open')
    }
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {`${t('add')} ${t('addtional')} ${t('text')}`}
      </PageTitle>
      <div className={`card ${className}`}>
        <div className='card-body '>
          <Form.Group className='mb-5' controlId='formBasicPassword'>
            <Form.Label>{t('Module')}</Form.Label>
            <Form.Select
              aria-label='Default select example'
              onChange={(e: any) => setModule(e.target.value)}
              defaultValue={module}
            >
              <option hidden value=''>
                {t('pilih')} {t('Module')}
              </option>
              {
                fullModules.map((item: any) => {
                  return <option key={item} selected={item == module} value={item}>{item}</option>
                })
              }
            </Form.Select>
          </Form.Group>

          <Form.Group className='mb-5' controlId='formBasicPassword'>
            <Form.Label>Sales Org</Form.Label>
            <Form.Select
              placeholder='Sales Org'
              onChange={(e: any) => setSales(e.target.value)}
            >
              <option selected hidden value=''>
                {t('pilih')} Sales Org
              </option>
              {fullSales.map((data: any) => {
                return (
                  <>
                    {data.code == localStorage.getItem('sales-organization') ? (
                      <option selected value={data.code}>
                        {data.code} - {data.name}
                      </option>
                    ) : (
                      <option value={data.code}>
                        {data.code} - {data.name}
                      </option>
                    )}
                  </>
                )
              })}
            </Form.Select>
          </Form.Group>

          <Form.Group className='mb-5' controlId='formBasicPassword'>
            <Form.Label>Sector</Form.Label>
            <Form.Select
              placeholder='Sales Org'
              onChange={(e: any) => setSector(e.target.value)}
            >
              <option selected hidden value=''>
                {t('pilih')} Sector
              </option>
              {fullSectors.map((data: any) => {
                return (
                  <>
                    <option selected={data.id == sector} value={data.id}>
                      {data.name}
                    </option>
                  </>
                )
              })}
            </Form.Select>
          </Form.Group>

          <div className="d-flex justify-content-end mb-3">
            <div style={{ maxWidth: 140 }} className='btn-lang d-flex'>
              <button
                className={'d-flex align-items-center me-1 ' + (addTextLanguage == 'id' ? 'active' : '')}
                onClick={() => setAddTextLanguage('id')}
              >
                <h6 className='ms-1'>Ind</h6>
              </button>
              <button
                className={'d-flex align-items-center me-1 ' + (addTextLanguage == 'en' ? 'active' : '')}
                onClick={() => setAddTextLanguage('en')}
              >
                <h6 className='ms-1'>Eng</h6>
              </button>
            </div>
          </div>


          {addTextLanguage == 'id' && <div>
            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'customer pic name'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('customer pic name')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'customer pic name'}>
                <Form.Control
                  className='mt-3'
                  as='textarea'
                  //maxLength={132}
                  aria-label='Default select example'
                  onChange={(e: any) => setCustPICName(e.target.value)}
                  placeholder={t('customer pic name')}
                  defaultValue={custPICName}
                />
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer pic name', setCustPICName, custPICName_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'customer pic position'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('customer pic position')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'customer pic position'}>
                <Form.Control
                  className='mt-3'
                  as='textarea'
                  //maxLength={132}
                  aria-label='Default select example'
                  onChange={(e: any) => setCustPICPosition(e.target.value)}
                  placeholder={t('customer pic position')}
                  defaultValue={custPICPosition}
                />
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer pic position', setCustPICPosition, custPICPosition_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'sailing date'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('sailing date')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'sailing date'}>
                {/* <DatePicker
                            className='form-control'
                            selected={sailingDate_}
                            onChange={(date: any) =>
                              handleSaveAdditionalText2(
                                'sailing date',
                                setSailingDate,
                                date,
                                setSailingDate_
                              )
                            }
                            dateFormat='yyyy/MM/dd'
                          /> */}
                <Form.Control
                  className='mt-3'
                  type='date'
                  aria-label='Default select example'
                  onChange={(date) =>
                    setSailingDate(date)
                  }
                  placeholder={t('sailing date')}
                  defaultValue={sailingDate}
                />
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText2('sailing date', setSailingDate, sailingDate_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                      <div className='d-flex align-items-center'>
                        <button
                          className='a btn btn-primary w-100'
                          data-target={'target' + 'port of discharge'}
                          onClick={handleOpenn}
                        >
                          <div className="text-light">{t('port of discharge')}</div>
                        </button>
                      </div>
                      <div className='fold' id={'target' + 'port of discharge'}>
                        <Form.Control
                          className='mt-3'
                          as='textarea'
                          //maxLength={132}
                          aria-label='Default select example'
                          onChange={(e: any) => setPortDischarge(e.target.value)}
                          placeholder={t('port of discharge')}
                          defaultValue={portDischarge}
                        />
                        <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('port of discharge', setPortDischarge, portDischarge)}>{t('Save')}</button>
                        </div>
                      </div>
                    </Form.Group> */}

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'port of loading'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('port of loading')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'port of loading'}>
                <RichText
                  containerClassName='mt-4'
                  content={portLoading}
                  onUpdate={({ editor }) => setPortLoading(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('port of loading', setPortLoading, portLoading_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'additional text bast'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('additional text bast')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'additional text bast'}>
                <RichText
                  containerClassName='mt-4'
                  content={textBAST}
                  onUpdate={({ editor }) => setTextBAST(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('additional text bast', setTextBAST, textBAST_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'sales division'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('sales division')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'sales division'}>
                <RichText
                  containerClassName='mt-4'
                  content={salesDivision}
                  onUpdate={({ editor }) => setSalesDivision(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('sales division', setSalesDivision, salesDivision_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'pic sales division'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('pic sales division')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'pic sales division'}>
                <RichText
                  containerClassName='mt-4'
                  content={picSalesDivision}
                  onUpdate={({ editor }) => setPicSalesDivision(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('pic sales division', setPicSalesDivision, picSalesDivision_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                      <div className='d-flex align-items-center'>
                        <button
                          className='a btn btn-primary w-100'
                          data-target={'target' + 'transportation media'}
                          onClick={handleOpenn}
                        >
                          <div className="text-light">{t('transportation media')}</div>
                        </button>
                      </div>
                      <div className='fold' id={'target' + 'transportation media'}>
                        <Form.Control
                          className='mt-3'
                          as='textarea'
                          //maxLength={132}
                          aria-label='Default select example'
                          onChange={(e: any) => setTransportMedia_(e.target.value)}
                          placeholder={t('transportation media')}
                          defaultValue={transportMedia}
                        />
                        <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('transportation media', setTransportMedia, transportMedia_)}>{t('Save')}</button>
                        </div>
                      </div>
                    </Form.Group> */}

            {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                      <div className='d-flex align-items-center'>
                        <button
                          className='a btn btn-primary w-100'
                          data-target={'target' + 'transportation media info'}
                          onClick={handleOpenn}
                        >
                          <div className="text-light">{t('transportation media info')}</div>
                        </button>
                      </div>
                      <div className='fold' id={'target' + 'transportation media info'}>
                        <Form.Control
                          className='mt-3'
                          as='textarea'
                          //maxLength={132}
                          aria-label='Default select example'
                          onChange={(e: any) => setTransportMediaInfo_(e.target.value)}
                          placeholder={t('transportation media info')}
                          defaultValue={transportMediaInfo}
                        />
                        <div className="d-flex justify-content-end">
                          <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('transportation media info', setTransportMediaInfo, transportMediaInfo_)}>{t('Save')}</button>
                        </div>
                      </div>
                    </Form.Group> */}

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'term and condition'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('terms_and_conditions')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'term and condition'}>
                <RichText
                  containerClassName='mt-4'
                  content={TOS}
                  onUpdate={({ editor }) => setTOS(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('term and condition', setTOS, TOS_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'term and condition si'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('terms_and_conditions')} SI</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'term and condition si'}>
                <RichText
                  containerClassName='mt-4'
                  content={TOSsi}
                  onUpdate={({ editor }) => setTOSsi(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('term and condition si', setTOSsi, TOSsi_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'customer attn'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('customer attn')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'customer attn'}>
                <RichText
                  containerClassName='mt-4'
                  content={attn}
                  onUpdate={({ editor }) => setAttn(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer attn', setAttn, attn_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'text penutup'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('text penutup')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'text penutup'}>
                <RichText
                  containerClassName='mt-4'
                  content={penutup}
                  onUpdate={({ editor }) => setPenutup(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('text penutup', setPenutup, penutup_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'eta moda angkut'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('eta moda angkut')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'eta moda angkut'}>
                <Form.Control
                  className='mt-3'
                  type='date'
                  aria-label='Default select example'
                  onChange={(date: any) => {
                    setETA(date)
                  }}
                  placeholder={t('eta moda angkut')}
                  defaultValue={ETA}
                />
                {/* <DatePicker
                            className='form-control'
                            selected={ETA_}
                            onChange={(date: any) =>
                              handleSaveAdditionalText2('eta moda angkut', setETA, date, setETA_)
                            }
                            dateFormat='yyyy/MM/dd'
                          /> */}
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('eta moda angkut', setETA, ETA_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'keterangan'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('keterangan')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'keterangan'}>
                <RichText
                  containerClassName='mt-4'
                  content={textKeterangan}
                  onUpdate={({ editor }) => setTextKeterangan(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('keterangan', setTextKeterangan, textKeterangan_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'referensi'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('referensi')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'referensi'}>
                <RichText
                  containerClassName='mt-4'
                  content={referensi}
                  onUpdate={({ editor }) => setReferensi(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('referensi', setReferensi, referensi_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'tanggal shipping instruction'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('tanggal shipping instruction')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'tanggal shipping instruction'}>
                <Form.Control
                  className='mt-3'
                  type='date'
                  aria-label='Default select example'
                  onChange={(date: any) => {
                    setShippingInstruction(date)
                  }}
                  placeholder={t('tanggal shipping instruction')}
                  defaultValue={shippingInstruction}
                />
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText2('tanggal shipping instruction', setShippingInstruction, shippingInstruction_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'invoice note'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('invoice note')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'invoice note'}>
                <RichText
                  containerClassName='mt-4'
                  content={invoice}
                  onUpdate={({ editor }) => setInvoice(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('invoice note', setInvoice, invoice_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'nomor export'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('nomorIzinExport')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'nomor export'}>
                <RichText
                  containerClassName='mt-4'
                  content={noExport}
                  onUpdate={({ editor }) => setNoExport(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                              <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('nomor export', setNoExport, noExport_)}>{t('Save')}</button>
                            </div> */}
              </div>
            </Form.Group>
            <hr />
          </div>}
          {addTextLanguage == 'en' && <div>
            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'additional text bast'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('additional text bast')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'additional text bast'}>
                <RichText
                  containerClassName='mt-4'
                  content={textBASTEn}
                  onUpdate={({ editor }) => setTextBASTEn(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('additional text bast', setTextBAST, textBAST_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'term and condition'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('terms_and_conditions')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'term and condition'}>
                <RichText
                  containerClassName='mt-4'
                  content={TOSEn}
                  onUpdate={({ editor }) => setTOSEn(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('term and condition', setTOS, TOS_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'term and condition si'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('terms_and_conditions')} SI</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'term and condition si'}>
                <RichText
                  containerClassName='mt-4'
                  content={TOSsiEn}
                  onUpdate={({ editor }) => setTOSsiEn(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('term and condition si', setTOSsi, TOSsi_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'customer attn'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('customer attn')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'customer attn'}>
                <RichText
                  containerClassName='mt-4'
                  content={attnEn}
                  onUpdate={({ editor }) => setAttnEn(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer attn', setAttn, attn_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'text penutup'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('text penutup')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'text penutup'}>
                <RichText
                  containerClassName='mt-4'
                  content={penutupEn}
                  onUpdate={({ editor }) => setPenutupEn(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('text penutup', setPenutup, penutup_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'keterangan'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('keterangan')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'keterangan'}>
                <RichText
                  containerClassName='mt-4'
                  content={textKeteranganEn}
                  onUpdate={({ editor }) => setTextKeteranganEn(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('keterangan', setTextKeterangan, textKeterangan_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'referensi'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('referensi')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'referensi'}>
                <RichText
                  containerClassName='mt-4'
                  content={referensiEn}
                  onUpdate={({ editor }) => setReferensiEn(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('referensi', setReferensi, referensi_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />

            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <div className='d-flex align-items-center'>
                <button
                  className='a btn btn-primary w-100'
                  data-target={'target' + 'invoice note'}
                  onClick={(e: any) => handleOpenn(e)}
                >
                  <div className='text-light'>{t('invoice note')}</div>
                </button>
              </div>
              <div className='fold' id={'target' + 'invoice note'}>
                <RichText
                  containerClassName='mt-4'
                  content={invoiceEn}
                  onUpdate={({ editor }) => setInvoiceEn(editor.getHTML())}
                >
                  <div style={{ display: 'none' }}>&nbsp;</div>
                </RichText>
                {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('invoice note', setInvoice, invoice_)}>{t('Save')}</button>
                          </div> */}
              </div>
            </Form.Group>
            <hr />
          </div>}
        </div>

        <div className='d-flex justify-content-end p-8'>
          <Link to={'/config/optional-text'}>
            <Button className='btn btn-secondary me-2'>{t('berita-batal')}</Button>
          </Link>
          <Button className='btn btn-primary' onClick={() => handleUpload()} disabled={btnLoading}>
            {btnLoading ? (
              <Spinner animation='border' variant='light' size='sm' />
            ) : (
              t('order-kirim')
            )}
          </Button>
        </div>
      </div>
    </>
  )
}

export { AddOptionalText }
